import axios from "axios";

export default function validateUnassignRange({ payload }) {
  return new Promise((resolve, reject) =>
    axios
      .post('/distributor/system-admin/api/v1/unassign-validate', {
        node_id: payload.node_id,
        type: payload.type,
        range: payload.ranges.map((r) => ({ from: r.from, to: r.to })),
      })
      .then((response) => resolve(response.data))
      .catch((error) => {
        if (error.response && error.response.data) {
          const err = new Error(error.response.data.message);
          err.data = error.response.data;
          err.code = error.response.status;
          reject(err);
        } else {
          reject(error);
        }
      })
  );
}
